<script lang="ts">
    import UserMenu from "./UserMenu.svelte";

    const activator = document.getElementById(
        "navbar__user"
    ) as HTMLButtonElement;
    if (activator) {
        let userMenu: UserMenu | undefined;

        function syncBtnStateWithMenu(btn: HTMLButtonElement) {
            let open = btn.dataset["open"] === "true" || false;
            const menu = (btn as any).menu;
            if (menu) {
                setTimeout(() => menu.$set({ open }));
            }
        }

        function onClose() {
            const currentOpen = activator.dataset["open"] === "true" || false;
            activator.dataset["open"] = `${!currentOpen}`;
            syncBtnStateWithMenu(activator);
        }

        function onActivatorClick() {
            if (userMenu) {
                activator.dataset["open"] = "true";
                syncBtnStateWithMenu(activator);
            } else {
                const container = document.createElement("div");
                container.classList.add("relative");
                container.style.alignSelf = "flex-end";
                activator.parentNode.insertBefore(
                    container,
                    activator.nextSibling
                );
                userMenu = new UserMenu({
                    target: container,
                    props: {
                        userId: activator.dataset["userid"],
                        onClose,
                    },
                });
                (activator as any).menu = userMenu;

                activator.dataset["open"] = "true";
                syncBtnStateWithMenu(activator);
            }
        }

        activator.addEventListener("click", onActivatorClick);
    }
</script>
